import React from 'react';
import './ServicePage.css';

function ServicePage() {
  return (
    <div className="service-page">
      <div className="service-header">
        <h2>Our Services</h2>
        <div className="licensed-badge">
          <span className="badge-text">Licensed Home Daycare</span>
          <span className="badge-subtext">CWELCC Program</span>
        </div>
      </div>
      
      <div className="services-grid">
        <div className="service-card">
          <div className="service-icon">🏠</div>
          <h3>Full Day Daycare</h3>
          <p className="service-description">Comprehensive full-day care in our nurturing home environment</p>
          <div className="cwelcc-badge">
            <span className="badge-icon">🇨🇦</span>
            <span>Licensed & CWELCC Subsidized</span>
          </div>
          <div className="availability-notice">
            <div className="availability-header">
              <span className="availability-badge">Limited Availability</span>
            </div>
            <p>We still have 1 spot for September. Reach out as soon as possible!</p>
          </div>
        </div>
        
        <div className="service-card">
          <div className="service-icon">🌅</div>
          <h3>Before and After School Care</h3>
          <p className="service-description">Flexible care before and after school hours</p>
          <div className="availability-notice">
            <div className="availability-header">
              <span className="availability-badge">Flexible</span>
            </div>
            <p>We can discuss on case by case basis</p>
          </div>
        </div>
        
        <div className="service-card">
          <div className="service-icon">☀️</div>
          <h3>Half-Day Care</h3>
          <p className="service-description">Part-time care options for your family's needs</p>
          <div className="availability-notice">
            <div className="availability-header">
              <span className="availability-badge">Flexible</span>
            </div>
            <p>We can discuss on case by case basis</p>
          </div>
        </div>
      </div>
      
      <div className="program-info">
        <h3>About CWELCC Program</h3>
        <p>Our Full Day Daycare is licensed and participates in the Canada-Wide Early Learning and Child Care (CWELCC) program, ensuring high-quality, affordable child care for families. Before/After and Half-Day services are offered as additional flexible options.</p>
        
        <div className="safety-certifications">
          <h4>Safety & Certifications</h4>
          <div className="certification-grid">
            <div className="certification-item">
              <span className="cert-icon">🩹</span>
              <div className="cert-content">
                <h5>First Aid & CPR</h5>
                <p>All staff have Standard First Aid and CPR certification</p>
              </div>
            </div>
            
            <div className="certification-item">
              <span className="cert-icon">👮‍♂️</span>
              <div className="cert-content">
                <h5>Police Checks</h5>
                <p>All staff and residents have completed vulnerable sector police checks</p>
              </div>
            </div>
            
            <div className="certification-item">
              <span className="cert-icon">💉</span>
              <div className="cert-content">
                <h5>Immunizations</h5>
                <p>All staff and residents are fully up to date on required immunizations</p>
              </div>
            </div>
            
            <div className="certification-item">
              <span className="cert-icon">🚒</span>
              <div className="cert-content">
                <h5>Fire Safety</h5>
                <p>Home daycare has passed fire safety inspection by the fire department</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ServicePage;